// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-header{background:#000!important;border-color:#000!important;font-size:16px;color:#fff}.el-table__body-wrapper{z-index:2}.el-table__fixed,.el-table__fixed-right{box-shadow:none;position:absolute;top:0;right:0;bottom:0;content:\"\";z-index:100;box-shadow:0 0 10px rgba(0,0,0,.12)}.el-table .cell{font-size:18px;white-space:pre-line;overflow:unset}", ""]);
// Exports
module.exports = exports;
